Wee.fn.make('alert', {
	top: function(conf) {
		Wee.fn.alertTop(conf);
	}
});